import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { useForgotPassword } from './useForgotPassword';

export const ForgotPassword = () => {
  const { errors, onSubmit, register } = useForgotPassword();

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Mot de passe oublié
        </Typography>
        <Box sx={{ mt: 1 }}>
          <form onSubmit={onSubmit}>
            <TextField
              margin="normal"
              fullWidth
              id="email"
              label="Adresse email"
              autoComplete="email"
              autoFocus
              type="email"
              {...register('email')}
              helperText={
                errors.email?.message ? (
                  <Typography component="p" variant="body2" color="error.main">
                    {errors.email.message}
                  </Typography>
                ) : null
              }
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Envoyer un email de réinitialisation
            </Button>
          </form>
          <Grid container>
            <Grid item xs>
              <Link href="/login" variant="body2">
                {`Tu t'en souviens ? Connecte-toi`}
              </Link>
            </Grid>
            <Grid item>
              <Link href="/create-account" variant="body2">
                Pas de compte ? Inscris-toi
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Container>
  );
};
